<template>
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-lg-8">

        <!-- 日本語版: 特定商取引法に基づく表記 -->
        <template v-if="locale === 'ja'">
          <h1 class="mb-4">特定商取引法に基づく表記</h1>
          <p class="text-muted mb-4">最終更新日：2026年4月17日</p>

          <table class="table table-bordered mb-4">
            <tbody>
              <tr>
                <th scope="row" style="width: 35%">販売業者</th>
                <td>ソフトリーチ株式会社</td>
              </tr>
              <tr>
                <th scope="row">代表者氏名</th>
                <td>束 凱文（Kevin Shu）</td>
              </tr>
              <tr>
                <th scope="row">所在地</th>
                <td>〒111-0053 東京都台東区浅草橋１ー１ー９</td>
              </tr>
              <tr>
                <th scope="row">電話番号</th>
                <td>+81 70-8910-5635</td>
              </tr>
              <tr>
                <th scope="row">メールアドレス</th>
                <td><a href="mailto:hello@kikuflow.com">hello@kikuflow.com</a></td>
              </tr>
              <tr>
                <th scope="row">販売URL</th>
                <td><a href="https://kikuflow.com">https://kikuflow.com</a></td>
              </tr>
              <tr>
                <th scope="row">販売価格</th>
                <td>
                  各プランの料金は<a href="/ja/pricing">料金ページ</a>をご参照ください。<br>
                  表示価格は米ドル（USD）建てです。消費税（10%）が別途加算されます。
                </td>
              </tr>
              <tr>
                <th scope="row">代金以外に必要な費用</th>
                <td>国内のお客様には消費税（10%）が別途加算されます。海外からのご利用には消費税は適用されません。インターネット接続に必要な通信費はお客様のご負担となります。</td>
              </tr>
              <tr>
                <th scope="row">支払方法</th>
                <td>クレジットカード（Visa・Mastercard・American Express・JCB）</td>
              </tr>
              <tr>
                <th scope="row">代金の支払時期</th>
                <td>毎月の契約開始日に自動引き落とし</td>
              </tr>
              <tr>
                <th scope="row">サービス提供時期</th>
                <td>決済完了後、即時にサービスをご利用いただけます。</td>
              </tr>
              <tr>
                <th scope="row">返品・キャンセル</th>
                <td>
                  アカウント設定からいつでも解約できます。解約後も当該請求期間の終了まではサービスをご利用いただけます。<br>
                  デジタルサービスの性質上、既に請求済みの料金の返金は原則行っておりません。
                </td>
              </tr>
              <tr>
                <th scope="row">動作環境</th>
                <td>
                  最新バージョンのGoogle Chrome・Mozilla Firefox・Safari・Microsoft Edgeに対応しています。<br>
                  インターネット接続環境が必要です。
                </td>
              </tr>
            </tbody>
          </table>
        </template>

        <!-- English version: Commerce Disclosure -->
        <template v-else>
          <h1 class="mb-4">Commerce Disclosure</h1>
          <p class="text-muted mb-4">Last updated: April 17, 2026</p>

          <section class="mb-4">
            <p><strong>1. Business Information</strong></p>
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th scope="row" style="width: 35%">Company Name</th>
                  <td>SoftReach Co., Ltd. (ソフトリーチ株式会社)</td>
                </tr>
                <tr>
                  <th scope="row">Representative</th>
                  <td>束 凱文 (Kevin Shu)</td>
                </tr>
                <tr>
                  <th scope="row">Address</th>
                  <td>〒111-0053 1-1-9 Asakusabashi, Taito-ku, Tokyo, Japan</td>
                </tr>
                <tr>
                  <th scope="row">Phone</th>
                  <td>+81 70-8910-5635</td>
                </tr>
                <tr>
                  <th scope="row">Contact Email</th>
                  <td><a href="mailto:hello@kikuflow.com">hello@kikuflow.com</a></td>
                </tr>
              </tbody>
            </table>
          </section>

          <section class="mb-4">
            <p><strong>2. Products and Services</strong></p>
            <p>kikuflow is a cloud-based workflow automation platform that enables organizations to digitize, automate, and manage approval processes. Services are provided as a monthly or annual SaaS subscription.</p>
          </section>

          <section class="mb-4">
            <p><strong>3. Pricing</strong></p>
            <p>Subscription plans and pricing are listed on our <a href="/pricing">Pricing page</a>. All prices are in USD. Consumption tax (10%) applies to customers in Japan; overseas customers are not subject to consumption tax.</p>
          </section>

          <section class="mb-4">
            <p><strong>4. Payment</strong></p>
            <p>We accept Visa, Mastercard, American Express, and JCB. Subscriptions are billed monthly on the subscription start date.</p>
          </section>

          <section class="mb-4">
            <p><strong>5. Cancellation Policy</strong></p>
            <p>You may cancel your subscription at any time from your account settings. Upon cancellation, you will continue to have access to the service until the end of your current billing period. No prorated refunds are issued for unused time.</p>
          </section>

          <section class="mb-4">
            <p><strong>6. Refund Policy</strong></p>
            <p>All sales are final. We do not offer refunds for subscription fees already charged.</p>
          </section>

          <section class="mb-4">
            <p><strong>7. Delivery</strong></p>
            <p>kikuflow is a digital service delivered via the internet. Access is granted immediately upon successful payment. No physical goods are shipped.</p>
          </section>

          <section class="mb-4">
            <p><strong>8. System Requirements</strong></p>
            <p>Supported browsers: latest versions of Google Chrome, Mozilla Firefox, Safari, and Microsoft Edge. An internet connection is required.</p>
          </section>
        </template>

      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

// Commerce disclosure page - required by Stripe for payment processing
const { locale } = useI18n()
</script>
